import { apiGet, apiPost, apiPut, apiDelete, apiPatch } from './client';

export interface CreateEventData {
  title: string;
  description: string;
  date: string;
  time: string;
  venue: string;
  venueId?: string;
  category: string;
  price: number;
  capacity: number;
  image: string;
  tags?: string[];
}

export interface UpdateEventData extends Partial<CreateEventData> {
  status?: 'DRAFT' | 'PUBLISHED' | 'SOLD_OUT' | 'CANCELLED';
}

export interface EventsQuery {
  category?: string;
  search?: string;
  minPrice?: number;
  maxPrice?: number;
  page?: number;
  limit?: number;
  status?: string;
}

export const eventsApi = {
  // Public endpoints
  getPublishedEvents: (query?: EventsQuery): Promise<any> => {
    return apiGet('/events/published', { params: query });
  },

  getAllEvents: (query?: EventsQuery): Promise<any> => {
    return apiGet('/events', { params: query });
  },

  getEventById: (id: string): Promise<any> => {
    return apiGet(`/events/${id}`);
  },

  // Admin endpoints
  getMyEvents: (query?: EventsQuery): Promise<any> => {
    return apiGet('/events/admin/my-events', { params: query });
  },

  createEvent: (data: CreateEventData): Promise<any> => {
    return apiPost('/events', data);
  },

  updateEvent: (id: string, data: UpdateEventData): Promise<any> => {
    return apiPut(`/events/${id}`, data);
  },

  deleteEvent: (id: string): Promise<any> => {
    return apiDelete(`/events/${id}`);
  },

  publishEvent: (id: string): Promise<any> => {
    return apiPatch(`/events/${id}/publish`);
  },

  getEventStats: (id: string): Promise<any> => {
    return apiGet(`/events/${id}/stats`);
  },
};

